import { createMachine, assign } from 'xstate';
import { preOrder } from '../requests/pre-order';
import { PreOrderPayload } from '@fingermarkglobal/types';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;
    
    if (data) {
      logger.debug(`[@fingermarkglobal/api]: Pre order FSM data recieved:`, data);
      return data
    };

    if (error) {
      logger.error(`[@fingermarkglobal/api]: Pre order FSM error recieved:`, error);
      return error
    };

    logger.error(`[@fingermarkglobal/api]: Pre order FSM message recieved:`, message);
    return message;
  }
});

const createPreOrderMachine = ({ payload = null, timeout = 30, ip = undefined, provider = '' } = {}) =>
  createMachine<{
    ip?: string;
    data: unknown;
    timeout: number;
    payload: null | PreOrderPayload;
    provider: string;
  }>(
    {
      id: 'preOrder',
      initial: 'processing',
      context: {
        ip,
        payload,
        timeout,
        data: null,
        provider,
      },
      states: {
        processing: {
          invoke: {
            src: ({ payload, timeout }) => preOrder(payload, timeout, ip, provider),
            onDone: {
              target: 'success',
              actions: ['populateMessage']
            },
            onError: {
              target: 'error',
              actions: ['populateMessage']
            }
          }
        },
        success: {
          on: {
            // TODO: rename this
            IDLE: 'processing'
          }
        },
        error: { type: 'final' }
      }
    },
    {
      actions: {
        populateMessage
      }
    }
  );

export { createPreOrderMachine };
